import { Navigate, Route, Routes } from 'react-router';
import { RefundRequestDetails } from './pages/refund-request-details';
import { ResourceApprovalDetails } from './pages/resource-approval-details';
import { Review } from './pages/review';
import { SubsidyManagement } from '.';

export const SubsidyManagementRoutes = () => {
  return (
    <Routes>
      <Route index element={<SubsidyManagement />} />
      <Route path="avaliar-pedido/:id" element={<Review />} />
      <Route path="detalhes/:id" element={<ResourceApprovalDetails />} />
      <Route
        path="detalhes/:id/:refund_request_uuid"
        element={<RefundRequestDetails />}
      />
      <Route
        path="*"
        element={<Navigate to="/gestao-de-reembolsos" replace />}
      />
    </Routes>
  );
};
